import React from 'react';
import { FullViewProps } from '../types';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import CommissionCover from './CommissionCover';
import { getDeviationTitle } from '../../_helpers';

import s from './Commission.scss';

export const CommissionFullView: React.FC<FullViewProps> = ({ deviation }) => {
  const deviationTitle = getDeviationTitle(deviation);
  return (
    <div className={s['root']}>
      <CentralColumn>
        <CommissionCover deviation={deviation} />
        <h1 className={s['header']}>{deviationTitle}</h1>
      </CentralColumn>
    </div>
  );
};
CommissionFullView.displayName = 'CommissionFullView';

export default CommissionFullView;
